<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Bottom v-if="url !== '/product'"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Bottom from '@/components/Bottom'

export default {
  name: 'App',
  components: {
    Header,
    Bottom
  },
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.url = this.$route.path
  },
  watch: {
    $route (to, from) {
      this.url = to.path
    }
  }
}
</script>

<style>
@import './style/common.less';
#app{
  height:100%;
  width:100%;
}
.headerEmpty {
  height:70px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue